<lgb-header-gradient [background]="true"></lgb-header-gradient>
<div class="screen-container">
	<lgb-back></lgb-back>
	<h1 class="element-show my-4 text-center" [style.--i]="0">
		<span class="brand">Legend</span>
		<i class="text-primary fa-regular fa-plus"></i>
	</h1>
	<p class="text-center opacity-60 mb-4">
		Passe au niveau légendaire
	</p>

	<!-- offre legend+ -->
	<fieldset class="mb-4 text-base fieldset border-base-300 rounded-box border p-4 glass">
		<div class="mb-2 badge badge-primary">Populaire</div>
		<h2>Legend <i class="text-primary fa-regular fa-plus"></i></h2>
		<p class="mt-2 text-xl font-bold">
			2,50€
			<span class="text-base font-normal text-base-content/60">/ mois</span> 
		</p>
		<p class="my-1 mb-2 text-primary">
			L’expérience complète, sans limite.
		</p>
		<div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-rectangle-vertical-history"></i>
				Compatible avec tous les binders
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-barcode-scan"></i>
				Scans illimités
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-cart-shopping-fast"></i>
				Prix market place
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-cards-blank"></i>
				Détection automatique des cartes
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-piggy-bank"></i>
				Estimation automatique des prix
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-paper-plane"></i>
				Partage simplifié
			</div>
		</div>
		<span class="my-1 ml-1 text-xs opacity-60">Facturé annuellement, soit 29,90€</span>
		<button (click)="placeOrder()" class="btn btn-primary btn-gradient my-3">Activer</button>
	</fieldset>

	<!-- offre free -->
	<fieldset class="element-show text-base fieldset border-base-300 rounded-box border p-4 glass" [style.--i]="2">
		<div class="mb-2 badge badge-soft badge-primary">Accès limité</div>
		<h2>Acces Indigo</h2>
		<p class="mt-2 text-xl font-bold">
			0€
			<span class="text-base font-normal text-base-content/60">/ mois</span>
		</p>
		<p class="my-1 text-primary mb-2">
			Incluse avec les binders Plateau-Indigo.
		</p>
		<div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-cart-shopping-fast"></i>
				Prix market place
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-cards-blank"></i>
				Détection automatique des cartes
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-piggy-bank"></i>
				Estimation automatique des prix
			</div>
			<div class="fonction-item">
				<i class="fonction-icon text-primary fa-regular fa-paper-plane"></i>
				Partage simplifié
			</div>
			<div class="fonction-item opacity-60">
				<i class="fonction-icon text-primary fa-regular fa-rectangle-vertical-history"></i>
				Limité aux binders Plateau-Indigo
			</div>
			<div class="fonction-item opacity-60">
				<i class="fonction-icon text-primary fa-regular fa-barcode-scan"></i>
				Scans limités
			</div>
		</div>
		<button class="btn btn-primary btn-soft my-3"><i class="fa-solid fa-check"></i> Inclu</button>
	</fieldset>
</div>